import { Scale, Flame } from 'lucide-react';
import { NO_TENSIONS_DETECTED_TEXT } from '../../data/resultCopy';
import type { Recommendation } from '../../data/schemas';
import type { DetectedTension } from '../../types/result';
import { TensionCard } from './TensionCard';
import { SectionHeading } from './SectionHeading';

interface TensionsSectionProps {
  tensions: readonly DetectedTension[];
  maximumFeatured: number;
  recommendations: readonly Recommendation[];
}

/** Prominente Darstellung der wichtigsten Spannungsfelder plus weitere im Detail (Abschnitt 17.5). */
export function TensionsSection({
  tensions,
  maximumFeatured,
  recommendations,
}: TensionsSectionProps) {
  if (tensions.length === 0) {
    return (
      <section className="stack">
        <SectionHeading icon={Scale}>Spannungsfelder</SectionHeading>
        <p className="card card--muted">{NO_TENSIONS_DETECTED_TEXT}</p>
      </section>
    );
  }

  const featured = tensions.slice(0, maximumFeatured);
  const remaining = tensions.slice(maximumFeatured);

  return (
    <>
      <section className="stack">
        <SectionHeading icon={Flame}>Wichtigste Reibungspunkte</SectionHeading>
        <div className="cluster-grid">
          {featured.map((tension) => (
            <TensionCard key={tension.ruleId} tension={tension} recommendations={recommendations} />
          ))}
        </div>
      </section>

      {remaining.length > 0 && (
        <section className="stack">
          <SectionHeading icon={Scale}>Weitere Spannungsfelder</SectionHeading>
          <div className="cluster-grid">
            {remaining.map((tension) => (
              <TensionCard
                key={tension.ruleId}
                tension={tension}
                recommendations={recommendations}
              />
            ))}
          </div>
        </section>
      )}
    </>
  );
}
